import { createInertiaApp } from '@inertiajs/react'
import AppLayout from '../components/AppLayout'

const pages = import.meta.glob('../pages/**/*.jsx')

// The server stores every timestamp in UTC and has no way of knowing where the
// reader is sitting. Telling it once, in a cookie, is what makes "today" on a new
// form mean the operator's today rather than the office's. Display conversion is
// the browser's own doing — see components/dates.js.
const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
if (zone) {
  document.cookie = `time_zone=${encodeURIComponent(zone)}; path=/; max-age=31536000; samesite=lax`
}

createInertiaApp({
  resolve: async (name) => {
    const importPage = pages[`../pages/${name}.jsx`]
    if (!importPage) throw new Error(`Inertia page not found: app/frontend/pages/${name}.jsx`)

    const page = await importPage()
    // Every screen gets the sidebar + header shell, except the auth screens,
    // which are full-bleed. Setting it here keeps the shell mounted across
    // navigations instead of remounting it per page.
    if (!name.startsWith('Auth/') && page.default.layout === undefined) {
      page.default.layout = (content) => <AppLayout>{content}</AppLayout>
    }
    return page
  },

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      // One message per field is enough on screen; Rails sends the full list.
      withAllErrors: false,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_javascript_tag "inertia.jsx" %> to the Inertia-specific layout instead.',
    )
  }
})
